import { useEffect } from "react";

/**
 * useHotkeys — register global keyboard shortcuts.
 *
 * @param {Object<string, (e: KeyboardEvent) => void>} bindings
 *   Keys are lowercased key names (e.g. "space", "arrowleft", "?"), values
 *   are handlers. Handlers are skipped when the user is typing in an input,
 *   textarea, or contenteditable element.
 */
export default function useHotkeys(bindings, deps = []) {
  useEffect(() => {
    const isEditing = (el) => {
      if (!el) return false;
      const tag = el.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return true;
      if (el.isContentEditable) return true;
      return false;
    };

    const onKey = (e) => {
      if (isEditing(e.target)) return;
      // Normalise keys
      const raw = (e.key || "").toLowerCase();
      const map = { " ": "space", spacebar: "space" };
      const key = map[raw] || raw;
      const handler = bindings[key];
      if (handler) {
        handler(e);
      }
    };

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
